/*
 * トップページ
 */

(function ($) {

    const ind_mainvisual_swiper = new Swiper('.ind_mainvisual_swiper', {
        loop: true,
        speed: 1000,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
        direction: 'horizontal',
        allowTouchMove: false
    });

    const ind_works_swiper = new Swiper('.ind_works_swiper', {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,

        navigation: {
            nextEl: '.ind_works_swiper_next',
            prevEl: '.ind_works_swiper_prev',
        },

        pagination: {
            el: ".ind_works_swiper_pagination",
        },

        breakpoints: {
            1024: {
                slidesPerView: 3 // desktop
            }
        }
    });

    if (ind_works_swiper.params.slidesPerView >= ind_works_swiper.slides.length) {
        $('.ind_works_swiper_prev, .ind_works_swiper_next').hide();
    }

})(jQuery);